import { parseISO } from '@sequencehq/utils/dates'

export const servicePeriodStringToDates = ({
  startDate,
  endDate
}: {
  startDate: string
  endDate: string
}): {
  start: Date
  endInclusive: Date
} => {
  return {
    start: parseISO(startDate),
    endInclusive: parseISO(endDate)
  }
}
